import { Fade } from "react-awesome-reveal";
import Header from "./Header";
import React, { useState } from "react";
import emailjs from "emailjs-com";
import Footer from "./Footer";
export const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: "",
        question: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        console.log(
            "SERVICE:",
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            "TEMPLATE:",
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            "PUBLIC KEY:",
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );

        e.preventDefault();

        const templateParams = {
            from_name: formData.name,
            from_surname: formData.surname,
            from_email: formData.email,
            message: formData.question,
        };

        emailjs
            .send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                templateParams,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )

            .then(
                (response) => {
                    console.log("SUCCESS!", response.status, response.text);
                    alert("✅ Twoja wiadomość została wysłana!");
                    setFormData({
                        name: "",
                        surname: "",
                        email: "",
                        question: "",
                    });
                },
                (err) => {
                    console.error("FAILED...", err);
                    alert(
                        "❌ Nie udało się wysłać wiadomości. Spróbuj ponownie."
                    );
                }
            );
    };

    return (
        <Fade>
            <div className="contact_box">
                <div className="fade_header" duration={2000}>
                    <Header />
                </div>
                <div className="contact_box_info">
                    <div className="contact_info_header">
                        <h2>Czy masz pytania?</h2>
                    </div>
                    <div className="contact_links">
                        <div>
                            <i className="fa-solid fa-envelope"></i>
                            <a href="mailto:mag.olszy@gmail.com">
                                inzynier.olszynska@gmail.com
                            </a>
                        </div>
                        <div>
                            <i className="fa-solid fa-phone"></i>
                            +48 505-042-299
                        </div>
                        <div>
                            <a
                                href="https://www.linkedin.com/in/magdalena-olszyńska-0022409b/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fa-brands fa-linkedin"></i>
                            </a>
                        </div>
                    </div>
                    <div className="form">
                        {/* 💬 Contact Form */}
                        <form className="contact_form" onSubmit={handleSubmit}>
                            <div className="form_group">
                                <label htmlFor="name">Imię</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form_group">
                                <label htmlFor="surname">Nazwisko</label>
                                <input
                                    type="text"
                                    id="surname"
                                    name="surname"
                                    value={formData.surname}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form_group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form_group">
                                <label htmlFor="question">Twoje pytanie</label>
                                <textarea
                                    id="question"
                                    name="question"
                                    rows="4"
                                    value={formData.question}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="submit_btn">
                                Wyślij wiadomość
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </Fade>
    );
};

export default Contact;
